import swiperSlider from './src/components/swiper';

// Slider configs
const promoConfig = {
	slidesPerView: 1,
	slidesPerGroup: 1,
	spaceBetween: 0,
	autoplay: true,
	speed: 500,
	loop: true,
	grabCursor: true,
	pagination: {
		el: '.swiper-pagination',
		clickable: true,
	},
};

const brandsConfig = {
	slidesPerView: 2,
	slidesPerGroup: 2,
	spaceBetween: 45,
	autoplay: {
		enabled: true,
		delay: 2000,
	},
	// speed: 350,
	loop: true,
	grabCursor: false,
	breakpoints: {
		992: {
			slidesPerView: 6,
			slidesPerGroup: 1,
		},
		768: {
			slidesPerView: 4,
			slidesPerGroup: 1,
		},
	},
};

const heroConfig = {
	slidesPerView: 1,
	effect: 'fade',
	fadeEffect: { crossFade: true },
	spaceBetween: 0,
	autoplay: {
		enabled: true,
		delay: 2000,
	},
	speed: 1000,
	loop: true,
	grabCursor: false,
};

/*
const refConfig = {
	slidesPerView: 1,
	slidesPerGroup: 1,
	centeredSlides: true,
	spaceBetween: 0,
	loop: true,
	grabCursor: true,
	pagination: {
		el: '.swiper-pagination',
		clickable: true,
	},
	a11y: {
		prevSlideMessage: 'Previous slide',
		nextSlideMessage: 'Next slide',
	},
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	},
	breakpoints: {
		992: {
			slidesPerView: 2,
			slidesPerGroup: 1,
			centeredSlides: false,
		},
	},
};
*/

function allPages() {
	document.querySelector('.brand-slider') &&
		swiperSlider('.brand-slider', brandsConfig);
	document.querySelector('.promo-slider') &&
		swiperSlider('.promo-slider', promoConfig);
	document.querySelector('.hero-slider') &&
		swiperSlider('.hero-slider', heroConfig);
}

function initDOMLoaded() {
	document.removeEventListener('DOMContentLoaded', initDOMLoaded);
	allPages();
}

// Code runs after page loaded
document.addEventListener('DOMContentLoaded', initDOMLoaded);
